
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";
import React from "react";

export function InstallationGuide() {
  return (
    <>
      <Alert variant="default" className="mb-4">
        <AlertCircle className="h-4 w-4" />
        <AlertDescription>
          <strong>Important:</strong> Make sure to place this script in the <code className="bg-amber-50 px-1 rounded">&lt;head&gt;</code> section of your HTML.
        </AlertDescription>
      </Alert>
      
      <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-md">
        <h4 className="text-sm font-medium text-blue-800">Installation Instructions</h4>
        <ol className="text-sm text-blue-700 mt-2 list-decimal pl-5 space-y-1">
          <li>Copy the script above</li>
          <li>Paste it in the <code className="bg-blue-100 px-1 rounded">&lt;head&gt;</code> section of your website</li>
          <li>Make sure it appears before the closing <code className="bg-blue-100 px-1 rounded">&lt;/head&gt;</code> tag</li>
          <li>Save your changes and reload your website</li>
          <li>Click the "Test Pixel" button after your page has loaded</li>
        </ol>
      </div>
    </>
  );
}
